<template>
  <div>
    <Head :title="`${form.name}`" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-if="auth.user.role_admin || auth.user.role_main_agent"><Link href="/agencies">Agencies</Link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ form.name }}</li>
      </ol>
    </nav>

    <h1>
      {{ form.name }}
    </h1>
    <trashed-message v-if="agencies.deleted_at" class="mb-6" @restore="restore"> This agency has been deleted. </trashed-message>

    <div class="row">
      <div class="col-md-6">
        <div class="content-box mb-3">
          <h4>Agency details</h4>
          <table class="table">
            <tbody>
              <tr>
                <td>Name</td>
                <th scope="row">{{ agencies.name }}</th>
              </tr>
              <tr>
                <td>E-mail address</td>
                <th scope="row">{{ agencies.email }}</th>
              </tr>
              <tr>
                <td>Phone</td>
                <th scope="row">{{ agencies.phone }}</th>
              </tr>
              <tr>
                <td>Address</td>
                <th scope="row">{{ agencies.address_1 }} <div v-if="agencies.address_2">{{ agencies.address_2 }}</div></th>
              </tr>
              <tr>
                <td>ZIP</td>
                <th scope="row">{{ agencies.postal_code }}</th>
              </tr>
              <tr>
                <td>City</td>
                <th scope="row">{{ agencies.city }}</th>
              </tr>
              <tr>
                <td>State</td>
                <th scope="row">{{ agencies.state }}</th>
              </tr>
              <tr>
                <td>Country</td>
                <th scope="row">{{ agencies.country }}</th>
              </tr>
            </tbody>
          </table>

          <div class="actions-toolbar">
            <ShowLogs v-if="auth.user.role_admin" :logs="logs" />
            <Link :href="`/agencies/${agencies.id}/edit`" tabindex="-1" class="btn btn-primary">
              Edit Agency
            </Link>
            <button v-if="!agencies.deleted_at && agencies.id != 1 && auth.user.role_admin" class="btn btn-outline-danger" tabindex="-1" type="button" @click="destroy">Delete Agency</button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="content-box mb-3">
          <h4>Agents</h4>
          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="contact in agencies.agents.data" :key="contact.id">
                <td>
                  <Link :href="`/users/${contact.id}/edit`">
                    {{ contact.name }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/users/${contact.id}/edit`" tabindex="-1">
                    {{ contact.email }}
                  </Link>
                </td>
              </tr>
              <tr v-if="agencies.agents.data.length === 0">
                <td colspan="2">No agents found.</td>
              </tr>
            </tbody>
          </table>
          <pagination class="mt-3" :links="agencies.agents.links" />

          <Link :href="`/users/create`" tabindex="-1" class="btn btn-primary">
            Create User
          </Link>
        </div>
      </div>
    </div>

    <h2>Previous bookings</h2>

    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Status</th>
            <th>Booking Date</th>
            <th>Customer</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="booking in bookings.data" :key="booking.id">
            <td>
              <Link :href="`/bookings/${booking.id}/edit`">
                {{ booking.id }}
              </Link>
            </td>
            <td>
              <Link :href="`/bookings/${booking.id}/edit`">
                {{ booking.status }}
              </Link>
            </td>
            <td>
              <Link :href="`/bookings/${booking.id}/edit`">
                {{ $filters.formatDate(booking.created_at) }}
              </Link>
            </td>
            <td>
              <Link :href="`/bookings/${booking.id}/edit`">
                {{ booking.customers[0].first_name }} {{ booking.customers[0].middle_name }} {{ booking.customers[0].last_name }}
              </Link>
            </td>
          </tr>
          <tr v-if="bookings.data.length === 0">
            <td colspan="6">No bookings found.</td>
          </tr>
        </tbody>
      </table>

      <pagination class="mt-3" :links="bookings.links" />
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TrashedMessage from '@/Shared/TrashedMessage'
import Pagination from '@/Shared/Pagination'
import ShowLogs from '@/components/ShowLogs'

export default {
  components: {
    Head,
    Link,
    TrashedMessage,
    Pagination,
    ShowLogs
  },
  layout: Layout,
  props: {
    agencies: Object,
    bookings: Object,
    logs: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.agencies.name,
        email: this.agencies.email,
        phone: this.agencies.phone,
        address_1: this.agencies.address_1,
        address_2: this.agencies.address_2,
        city: this.agencies.city,
        region: this.agencies.region,
        country: this.agencies.country,
        postal_code: this.agencies.postal_code,
      }),
    }
  },
  computed: {
    auth() {
      return this.$page.props.auth
    }
  },
  methods: {
    destroy() {
      if (confirm('Are you sure you want to delete this agency?')) {
        this.$inertia.delete(`/agencies/${this.agencies.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this agency?')) {
        this.$inertia.put(`/agencies/${this.agencies.id}/restore`)
      }
    },
  }
}
</script>

<style>

</style>
